// extracted by mini-css-extract-plugin
module.exports = {"root":"_c289a0","disabled":"_70da26","small":"_6b4b1d","large":"_48ca44"};